import { University } from "@/store/types/universityTypes";
import { BookOpen } from "lucide-react";

const Programs = ({ universityDetail }: { universityDetail: University }) => {
  return (
    <div className="pt-[32px] sm:pt-[40px] md:pt-[46px] lg:pt-[56px]">
      <div className="bg-[#0E1116] rounded-[24px] py-[24px] px-4 sm:px-7 md:px-9 xl:px-[43px]">
        <p className="ff_poppins text-base text-white">TOTAL PROGRAMS</p>
        <p className="text-[32px] ff_poppins text-[#EB9757]">
          {universityDetail.programCount}
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-[16px] gap-y-[12px] mt-[24px]">
        {(universityDetail.streams?.length ?? 0) > 0 &&
          universityDetail.streams?.map((stream, index) => (
            <div
              key={index}
              className="border border-[#D0C4FF] py-3 px-3 sm:px-4 md:px-6 flex items-center gap-2 rounded-[12px] bg-white"
            >
              <BookOpen color="#EB9757" />
              <p className="text-sm font-medium ff_poppins capitalize">
                {stream}
              </p>
            </div>
          ))}
        {/* <div className="border border-[#D0C4FF] py-3 px-3 sm:px-4 md:px-6 flex items-center gap-2 rounded-[12px] bg-white">
          <BookOpen color="#EB9757" />
          <p className="text-sm font-medium ff_poppins">
            Medical and Healthcare
          </p>
        </div>
        <div className="border border-[#D0C4FF] py-3 px-3 sm:px-4 md:px-6 flex items-center gap-2 rounded-[12px] bg-white">
          <BookOpen color="#EB9757" />
          <p className="text-sm font-medium ff_poppins">
            Theoritical and Fundamental Sciences
          </p>
        </div>
        <div className="border border-[#D0C4FF] py-3 px-3 sm:px-4 md:px-6 flex items-center gap-2 rounded-[12px] bg-white">
          <BookOpen color="#EB9757" />
          <p className="text-sm font-medium ff_poppins">
            Information Technology
          </p>
        </div>
        <div className="border border-[#D0C4FF] py-3 px-3 sm:px-4 md:px-6 flex items-center gap-2 rounded-[12px] bg-white">
          <BookOpen color="#EB9757" />
          <p className="text-sm font-medium ff_poppins">Arts and Humanities</p>
        </div>
        <div className="border border-[#D0C4FF] py-3 px-3 sm:px-4 md:px-6 flex items-center gap-2 rounded-[12px] bg-white">
          <BookOpen color="#EB9757" />
          <p className="text-sm font-medium ff_poppins">Engineering</p>
        </div> */}
      </div>
    </div>
  );
};
export default Programs;
